<div class="container mb-custom">
  <div class="accordion shadow-sm" id="accordionExample">
    <div *ngFor="let stage of stages" class="accordion-item">
      <h2 class="accordion-header">
        <button class="accordion-button" type="button" data-bs-toggle="collapse"
          [attr.data-bs-target]="'#' + stage.category" aria-expanded="true" [attr.aria-controls]="stage.category"
          [ngClass]="{'accordion-dark': stage.type === 'blank'}">
          {{stage.title}}
        </button>
      </h2>
      <div id="{{stage.category}}" class="accordion-collapse collapse hide" data-bs-parent="#accordionExample">
        <div class="accordion-body">
          <div *ngIf="stage.type !== 'blank'" class="alert" role="alert"
            [ngClass]="{'alert-success': stage.type === 'success', 'alert-info':stage.type === 'info','alert-warning':stage.type === 'warning', 'alert-danger':stage.type === 'error'}">
            <p class="fw-bold">Request</p>
            <pre>{{stage.request | json}}</pre>

            <div *ngIf="stage.response">
              <hr />
              <p class="fw-bold">Response</p>
              <pre>{{stage.response | json}}</pre>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>